import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(ChartDataLabels);

export * from './LineChart';
export * from './HorizontalBarChart';
export * from './BarChart';
export * from './ScatterChart';